import React from 'react'
import Text from 'react-text'
import './index.styl'

export default function TabBar({activeTab, navigate, template}) {
  const setActiveTab = activeTab => navigate({activeTab}, undefined, {query: {template}}) 
  const buttonClassName = tab => `${tab}-button ${activeTab == tab ? 'active' : 'selectable'}`
  const onClick = tab => () => (activeTab != tab) && setActiveTab(tab)
  return (
    <div className="tab-bar">
      <div className={buttonClassName('catalogue')} onClick={onClick('catalogue')}>
        <Text id='catalogue' /> 
      </div>
    {/*
      <div className={buttonClassName('my-lessons')} onClick={onClick('my-lessons')}>
        <Text id='my-lessons' /> 
      </div>
      */}
    </div>
  )
}
